import { useWebConfigs } from 'providers/WebConfigsProvider';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Select from 'react-select';

const InitPageLayout = ({ children }) => {
  const { title, favicon } = useWebConfigs();

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
        <link rel='icon' type='image/png' href={favicon} sizes='16x16' />
      </Helmet>

      {children}

      {/* Hack: for load css from react-select */}
      <Select className='d-none css-load-for-select-multi-checkbox this-will-not-affect-anything' />
    </Fragment>
  );
};

export default InitPageLayout;
